const formatInputMoney = (num: any) => {
  if (num) {
    return Math.abs(Number(num)).toLocaleString("id");
  }
  return num.toString();
};
export default formatInputMoney;
